<template>
    <!-- Modal -->
    <div id="companyContactModal" class="modal fade" role="dialog">
        <div class="modal-dialog">

            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-lg">{{contact.name}}</h4>
                    <button type="button"
                            class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                            data-dismiss="modal">close
                    </button>
                </div>
                <div class="modal-body">
                    <form>
                        <div class="mb-2 leading-tight mr-2 md:w-3/4">
                            <label class="text-grey-darkest text-sm mb-0" for="date">Follow Up</label>
                            <div class="flex">
                                <input v-if="contact.date" type="checkbox" true-value="1" false-value="0"
                                    class="mr-2 mt-3"
                                    v-model="contact.completed">
                                <datetime type="datetime" id="date" name="date" v-model="contact.date" use12-hour
                                        :format="{ year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: '2-digit' }"
                                        :wrapper-class="contact.date ? 'w-3/5' : 'w-full'"
                                        input-class="bg-white leading-normal mt-2 tracking-wide shadow-sm appearance-none border rounded px-2 text-grey-darkest w-full focus:outline-none">
                                </datetime>
                                <button v-if="contact.date" @click.prevent.stop="removeMeeting(index)"
                                        class="material-icons text-grey-darkest text-xl focus:outline-none mt-2">
                                    clear
                                </button>
                            </div>
                        </div>
                        <div class="mb-2 leading-tight mr-2 md:w-3/4">
                            <label class="text-grey-darkest text-sm" for="status">Status</label>
                            <select v-model="contact.status" name="status" id="status"
                                    class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-full">
                                <option default></option>
                                <option value="pending">Pending</option>
                                <option value="won">Won</option>
                                <option value="lost">Lost</option>
                            </select>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button id="save-project-contact" name="save-project-contact"
                            @click.prevent="save"
                            class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                        Save
                    </button>
                    <button id="delete-project-contact" name="delete-project-contact"
                            @click.prevent="destroy"
                            class="bg-red hover:bg-red-darker px-3 py-1 rounded-full text-white focus:outline-none">
                        Delete
                    </button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

export default {
    props: ['project'],

    data() {
        return {
            contact: {
                index: '',
                id: -1,
                company: '',
                name: '',
                date: '',
                completed: '',
                status: ''
            },
        }
    },

    methods: {
        open(contact, index) {
            this.contact.index = index;
            this.contact.id = contact.id;
            this.contact.company = contact.company;
            this.contact.name = contact.name;
            this.contact.date = contact.date;
            this.contact.completed = contact.completed;
            this.contact.status = contact.status;

            $("#companyContactModal").modal('show');
        },

        save() {
            this.$emit('save', this.contact);
            $("#companyContactModal").modal('hide');
        },

        destroy() {
            this.$emit('destroy', this.contact);
            $("#companyContactModal").modal('hide');
        }
    }
}
</script>
